import React, { useState, useEffect, Fragment, useRef } from "react";
import FieldRenderer from "@/pages/user/forms/renderer/FieldRenderer";
import { CheckCircle2, } from "lucide-react";
import SaarcVisitFields from "./SaarcVisitFields";
import { MASTER_DATA } from "../config/masterData";


/**
 * PassengerFormTabs Component
 * @param {Object} config - Form configuration with sections and fields
 * @param {Object} values - Current form field values
 * @param {Object} errors - Validation errors keyed by field name
 * @param {Function} onChange - Callback for field value changes
 */



// function PassengerFormTabs({
//   config,
//   values,
//   errors,
//   onChange,
//   onSectionNext,
//   dropdownData,
//   readOnly = false,
//   allowNavigation = false,
//   mode = "edit", // "edit" | "review" | "view"
//   uploadedDocuments = [],
//   applicationId,
// }) {

//   const [activeSectionId, setActiveSectionId] = useState(null);
//   const [activeSubTabId, setActiveSubTabId] = useState(null);
//   const [visitedSections, setVisitedSections] = useState(new Set()); // ✅ Track unlocked sections
//   const [orderedSections, setOrderedSections] = useState([]); // ✅ Dynamically ordered sections

//   // ✅ UPDATED: Section ordering and initialization
//   useEffect(() => {
//     if (config?.sections?.length) {
//       let sections = [...config.sections];

//       // ✅ Find special sections
//       const uploadedDocsSection = sections.find(s => s.id === "uploaded_documents");
//       const additionalInfoSection = sections.find(s => s.id === "additional_info_requested");

//       // ✅ Check if additional info has any fields or data
//       const hasAdditionalInfo = additionalInfoSection && (
//         (additionalInfoSection.fields?.length > 0) ||
//         values.additional_info_requested
//       );

//       console.log('🔄 Section Ordering - Has Additional Info:', hasAdditionalInfo);

//       // ✅ Reorder sections
//       let ordered = sections.filter(s =>
//         s.id !== "uploaded_documents" &&
//         s.id !== "additional_info_requested"
//       );

//       // Build final order: uploaded_documents, additional_info (if exists), rest
//       const finalOrder = [];

//       if (uploadedDocsSection) {
//         finalOrder.push(uploadedDocsSection);
//       }

//       if (hasAdditionalInfo && additionalInfoSection) {
//         finalOrder.push(additionalInfoSection);
//       }

//       finalOrder.push(...ordered);

//       // If additional info exists but wasn't added, add it at the end
//       if (!hasAdditionalInfo && additionalInfoSection) {
//         finalOrder.push(additionalInfoSection);
//       }

//       setOrderedSections(finalOrder);

//       // ✅ Set default active section (first non-document section)
//       const defaultSection = hasAdditionalInfo && additionalInfoSection
//         ? additionalInfoSection
//         : (finalOrder[1] || finalOrder[0]);

//       setActiveSectionId(defaultSection.id);
//       setActiveSubTabId(defaultSection.subTabs?.[0]?.id || null);

//       // ✅ Mark initial visited sections
//       const initialVisited = new Set([defaultSection.id]);
//       if (uploadedDocsSection) {
//         initialVisited.add("uploaded_documents");
//       }
//       if (hasAdditionalInfo && additionalInfoSection) {
//         initialVisited.add("additional_info_requested");
//       }

//       setVisitedSections(initialVisited);
//     }
//   }, [config, values.additional_info_requested, uploadedDocuments?.length]);


//   // ✅ Early return with proper check
//   if (!config || !config.sections || orderedSections.length === 0) {
//     return <p className="text-gray-500">No form configuration available.</p>;
//   }

//   const activeSection = orderedSections.find((s) => s.id === activeSectionId);

//   // ✅ Check if current section uses custom renderer
//   const usesCustomRenderer = activeSection?.useCustomRenderer;
//   const CustomComponent = activeSection?.customComponent;

//   const shouldShowField = (field) => {
//     if (!field.show_when) return true;
//     const { field: dependsOn, equals } = field.show_when;
//     return values[dependsOn] === equals;
//   };

//   const getFields = () => {
//     if (!activeSection) return [];
//     if (activeSection.subTabs?.length) {
//       return (
//         activeSection.subTabs.find((t) => t.id === activeSubTabId)?.fields || []
//       );
//     }
//     return activeSection.fields || [];
//   };

//   const getVisibleFields = (fields) => {
//     return fields.filter((f) => shouldShowField(f));
//   };

//   // ✅ UPDATED: Fixed getFilled to properly check for empty values
//   const getFilled = (fields) => {
//     return fields.filter((field) => {
//       if (!field.name || !shouldShowField(field)) return false;

//       const val = values[field.name];

//       // ✅ Proper empty check for all field types
//       if (val === undefined || val === null || val === "") {
//         return false;
//       }

//       // Checkbox needs to be true
//       if (field.type === "checkbox") {
//         return val === true;
//       }

//       // File fields
//       if (field.type === "file") {
//         return Array.isArray(val) ? val.length > 0 : !!val;
//       }

//       // Arrays should have items
//       if (Array.isArray(val)) {
//         return val.length > 0;
//       }

//       return true;
//     }).length;
//   };

//   // ✅ UPDATED: Fixed getSectionStats for proper document count and field calculation
//   const getSectionStats = (section) => {
//     // ✅ For uploaded_documents - count actual documents
//     if (section.id === "uploaded_documents") {
//       const docCount = Array.isArray(uploadedDocuments) ? uploadedDocuments.length : 0;
//       console.log(`📄 Uploaded Docs Stats - Count: ${docCount}, Documents:`, uploadedDocuments);

//       // Return doc count as both total and filled
//       return {
//         total: Math.max(1, docCount), // At least 1 to show as a section
//         filled: docCount,
//       };
//     }

//     // ✅ For additional_info_requested
//     if (section.id === "additional_info_requested") {
//       if (section.fields?.length > 0) {
//         const visibleFields = getVisibleFields(section.fields);
//         const filledCount = getFilled(section.fields);
//         return {
//           total: visibleFields.length,
//           filled: filledCount,
//         };
//       }
//       // If no fields defined yet
//       return {
//         total: 1,
//         filled: 0,
//       };
//     }

//     // ✅ For other custom renderer sections
//     if (section.useCustomRenderer) {
//       return {
//         total: 1,
//         filled: 0,
//       };
//     }

//     // ✅ Regular field-based sections with sub-tabs
//     if (section.subTabs?.length) {
//       const total = section.subTabs.reduce(
//         (sum, tab) => sum + getVisibleFields(tab.fields || []).length,
//         0,
//       );
//       const filled = section.subTabs.reduce(
//         (sum, tab) => sum + getFilled(tab.fields || []),
//         0,
//       );
//       return { total, filled };
//     }

//     // ✅ Sections with direct fields
//     const visibleFields = getVisibleFields(section.fields || []);
//     return {
//       total: visibleFields.length,
//       filled: getFilled(section.fields || []),
//     };
//   };

//   const icons = {
//     uploaded_documents: "📋",
//     personal: "👤",
//     employment: "💼",
//     passport: "🛂",
//     address: "🏠",
//     travel: "✈️",
//     declaration: "📋",
//     additional_info_requested: "📝",
//   };

//   // ✅ UPDATED: handleSectionChange to use orderedSections
//   const handleSectionChange = (sectionId) => {
//     setActiveSectionId(sectionId);
//     const section = orderedSections.find((s) => s.id === sectionId);
//     setActiveSubTabId(section?.subTabs?.[0]?.id || null);

//     // Mark as visited
//     setVisitedSections(prev => new Set([...prev, sectionId]));
//   };

//   // ✅ UPDATED: handlePrevious to use orderedSections
//   const handlePrevious = () => {
//     // ✅ Check if current section has sub-tabs
//     if (activeSection?.subTabs && activeSection.subTabs.length > 0) {
//       const currentSubTabIdx = activeSection.subTabs.findIndex(
//         (t) => t.id === activeSubTabId
//       );

//       // If there's a previous sub-tab in the current section, move to it
//       if (currentSubTabIdx > 0) {
//         setActiveSubTabId(activeSection.subTabs[currentSubTabIdx - 1].id);
//         return; // Stay in current section
//       }
//     }

//     // ✅ No previous sub-tabs OR already on first sub-tab - move to previous section
//     const currentIdx = orderedSections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     if (currentIdx > 0) {
//       const prevSection = orderedSections[currentIdx - 1];
//       setActiveSectionId(prevSection.id);

//       // Set to LAST sub-tab of previous section if it has sub-tabs
//       if (prevSection.subTabs && prevSection.subTabs.length > 0) {
//         setActiveSubTabId(prevSection.subTabs[prevSection.subTabs.length - 1].id);
//       } else {
//         setActiveSubTabId(null);
//       }
//     }
//   };

//   // ✅ UPDATED: handleNext to use orderedSections
//   const handleNext = () => {
//     const currentIdx = orderedSections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     // ✅ Check if current section has sub-tabs
//     if (activeSection?.subTabs && activeSection.subTabs.length > 0) {
//       const currentSubTabIdx = activeSection.subTabs.findIndex(
//         (t) => t.id === activeSubTabId
//       );

//       // If there's a next sub-tab in the current section, move to it
//       if (currentSubTabIdx < activeSection.subTabs.length - 1) {
//         setActiveSubTabId(activeSection.subTabs[currentSubTabIdx + 1].id);

//         // PROGRESSIVE SAVE: Call save callback when moving between sub-tabs
//         if (onSectionNext && mode === "edit") {
//           onSectionNext();
//         }
//         return; // Stay in current section
//       }
//     }

//     // ✅ No more sub-tabs OR no sub-tabs at all - move to next section
//     if (currentIdx < orderedSections.length - 1) {
//       // PROGRESSIVE SAVE: Call save callback before moving to next section
//       if (onSectionNext && mode === "edit") {
//         onSectionNext();
//       }

//       const nextSection = orderedSections[currentIdx + 1];

//       // ✅ Mark next section as visited/unlocked
//       setVisitedSections(prev => new Set([...prev, nextSection.id]));

//       handleSectionChange(nextSection.id);
//     }
//   };

//   // ✅ UPDATED: Use orderedSections for first/last section check
//   const isFirstSection =
//     orderedSections.findIndex((s) => s.id === activeSectionId) === 0;

//   const isLastSection =
//     orderedSections.findIndex((s) => s.id === activeSectionId) ===
//     orderedSections.length - 1;

//   const resolveOptions = (field) => {
//     if (field.options_key && dropdownData[field.options_key]) {
//       return dropdownData[field.options_key].map((v) => ({
//         label: v,
//         value: v,
//       }));
//     }

//     if (field.options) {
//       return field.options.map((opt) =>
//         typeof opt === "string" ? { label: opt, value: opt } : opt
//       );
//     }

//     return [];
//   };

//   const groupFieldsBySection = (fields) => {
//     const groups = {};

//     fields.forEach((field) => {
//       const sectionName = field.section || "General Information";
//       if (!groups[sectionName]) {
//         groups[sectionName] = [];
//       }
//       groups[sectionName].push(field);
//     });

//     return groups;
//   };

//   const visibleFields = getVisibleFields(getFields());
//   const groupedFields = groupFieldsBySection(visibleFields);

//   // ✅ Render function for main content area
//   const renderMainContent = () => {
//     // If this section uses a custom component, render it
//     if (usesCustomRenderer && CustomComponent) {
//       return (
//         <div className="p-8">
//           <CustomComponent
//             uploadedDocuments={uploadedDocuments}
//             applicationId={applicationId}
//           />
//         </div>
//       );
//     }

//     // Otherwise, render regular fields
//     return (
//       <div className="p-8 max-h-[500px] overflow-y-auto">
//         {Object.entries(groupedFields).map(([sectionName, fields]) => (
//           <div key={sectionName} className="mb-8 last:mb-0">
//             <div className="mb-4 pb-2 border-b border-gray-200">
//               <h3 className="text-base font-semibold text-gray-800">
//                 {sectionName}
//               </h3>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
//               {fields.map((field, index) => {
//                 const isFullWidth =
//                   field.type === "textarea" ||
//                   field.fullWidth ||
//                   field.type === "checkbox";

//                 return (
//                   <div
//                     key={field.name || index}
//                     className={isFullWidth ? "md:col-span-2" : ""}
//                   >
//                     <FieldRenderer
//                       field={{
//                         ...field,
//                         options: resolveOptions(field),
//                       }}
//                       value={values[field.name]}
//                       error={errors[field.name]}
//                       onChange={onChange}
//                       readOnly={readOnly}
//                     />
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         ))}

//         {visibleFields.length === 0 && !usesCustomRenderer && (
//           <div className="text-center py-12 text-gray-500">
//             <p>No fields to display in this section.</p>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl">
//       {/* MAIN BODY */}
//       <div className="flex gap-6 p-6 max-w-7xl mx-auto">

//         {/* SIDEBAR - ✅ UPDATED to use orderedSections */}
//         <aside className="w-64 flex-shrink-0 space-y-3 max-h-[600px] overflow-y-auto pr-2">
//           {orderedSections.map((section) => {
//             const { total, filled } = getSectionStats(section);
//             const isActive = section.id === activeSectionId;
//             const isDone = total > 0 && filled === total;
//             const percentage = total > 0 ? (filled / total) * 100 : 0;

//             const isUnlocked = visitedSections.has(section.id) ||
//               section.id === "uploaded_documents" ||
//               section.id === "additional_info_requested";
//             const isClickable = mode !== "edit" || allowNavigation || isUnlocked;

//             // ✅ Determine what to show for count
//             let countDisplay;
//             if (section.id === "uploaded_documents") {
//               const docCount = uploadedDocuments?.length || 0;
//               countDisplay = `${docCount} ${docCount === 1 ? 'document' : 'documents'}`;
//             } else {
//               countDisplay = `${filled}/${total} fields`;
//             }

//             return (
//               <button
//                 key={section.id}
//                 onClick={() => isClickable && handleSectionChange(section.id)}
//                 disabled={!isClickable}
//                 className={`w-full p-4 rounded-xl text-left transition-all ${isActive
//                     ? "bg-white shadow-lg scale-105 border-2 border-blue-500"
//                     : isClickable
//                       ? "bg-white/70 hover:bg-white hover:shadow-md"
//                       : "bg-gray-100/50 cursor-not-allowed opacity-60"
//                   }`}
//               >
//                 <div className="flex items-center gap-3 mb-3">
//                   <span className="text-3xl flex-shrink-0">
//                     {icons[section.id] || "📄"}
//                   </span>
//                   <div className="flex-1 min-w-0">
//                     {/* ✅ Multi-line text support for long section names */}
//                     <h4
//                       className={`font-semibold text-sm leading-tight ${isClickable ? "text-gray-800" : "text-gray-400"
//                         }`}
//                       style={{
//                         display: '-webkit-box',
//                         WebkitLineClamp: 2,
//                         WebkitBoxOrient: 'vertical',
//                         overflow: 'hidden',
//                         wordBreak: 'break-word',
//                         lineHeight: '1.3'
//                       }}
//                     >
//                       {section.title}
//                     </h4>
//                     <p className={`text-xs mt-1 ${isClickable ? "text-gray-500" : "text-gray-400"
//                       }`}>
//                       {countDisplay}
//                     </p>
//                   </div>
//                   {isDone && (
//                     <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" />
//                   )}
//                 </div>

//                 <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
//                   <div
//                     className="h-full bg-blue-500 rounded-full transition-all duration-500"
//                     style={{ width: `${percentage}%` }}
//                   />
//                 </div>
//               </button>
//             );
//           })}
//         </aside>


//         {/* FORM AREA */}
//         <main className="flex-1 min-w-0">
//           <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

//             {/* SUB-TABS - Only show if NOT using custom renderer */}
//             {!usesCustomRenderer && activeSection?.subTabs && activeSection.subTabs.length > 0 && (
//               <div className="border-b bg-gray-50 px-6 pt-4">
//                 <div className="flex gap-2 overflow-x-auto pb-0">
//                   {activeSection.subTabs.map((tab) => {
//                     const visibleTabFields = getVisibleFields(tab.fields || []);
//                     const filled = getFilled(tab.fields || []);
//                     const total = visibleTabFields.length;
//                     const active = tab.id === activeSubTabId;
//                     const isComplete = filled === total && total > 0;

//                     return (
//                       <button
//                         key={tab.id}
//                         onClick={() => setActiveSubTabId(tab.id)}
//                         className={`px-6 py-3 rounded-t-lg font-medium text-sm transition-all whitespace-nowrap ${active
//                           ? "bg-white text-blue-600 border-t-2 border-x-2 border-blue-600"
//                           : "text-gray-600 hover:bg-white/50"
//                           }`}
//                       >
//                         <div className="flex items-center gap-2">
//                           <span>{tab.title}</span>
//                           {isComplete && (
//                             <CheckCircle2 className="w-4 h-4 text-green-500" />
//                           )}
//                         </div>
//                         <div className="text-xs mt-1 opacity-90">
//                           {filled}/{total}
//                         </div>
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}

//             {/* ✅ Render either custom component or fields */}
//             {renderMainContent()}

//             {/* FOOTER - NAVIGATION (ONLY IN EDIT MODE) */}
//             {mode === "edit" && (
//               <div className="border-t bg-gray-50 p-6 flex justify-between items-center">
//                 <button
//                   onClick={handlePrevious}
//                   disabled={isFirstSection}
//                   className={`px-6 py-2.5 rounded-lg font-medium transition-all ${isFirstSection
//                     ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                     : "bg-white text-gray-700 hover:shadow-md border border-gray-300"
//                     }`}
//                 >
//                   ← Previous
//                 </button>

//                 {!isLastSection && (
//                   <button
//                     onClick={handleNext}
//                     className="px-6 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-md font-medium transition-all flex items-center gap-2"
//                   >
//                     <span>Next</span>
//                     <span>→</span>
//                   </button>
//                 )}
//               </div>
//             )}

//             {/* INFO IN REVIEW/VIEW MODE */}
//             {(mode === "review" || mode === "view") && (
//               <div className="border-t bg-gray-50 p-6 text-center">
//                 {/* You can add review mode info here */}
//               </div>
//             )}
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// }

// function PassengerFormTabs({
//   config,
//   values,
//   errors,
//   onChange,
//   onSectionNext, 
//   dropdownData,
//   readOnly = false,
//   allowNavigation = false,
//   mode = "edit",
//   uploadedDocuments = [], 
//   applicationId,
// }) {

//   const [activeSectionId, setActiveSectionId] = useState(null);
//   const [activeSubTabId, setActiveSubTabId] = useState(null);

//   console.log("Values", values);

//   useEffect(() => {
//     if (config?.sections?.length) {
//       const first = config.sections[0];
//       setActiveSectionId(first.id);
//       setActiveSubTabId(first.subTabs?.[0]?.id || null);
//     }
//   }, [config]);

//   if (!config || !config.sections) {
//     return <p className="text-gray-500">No form configuration available.</p>;
//   }

//   const activeSection = config.sections.find((s) => s.id === activeSectionId);
//   const usesCustomRenderer = activeSection?.useCustomRenderer;
//   const CustomComponent = activeSection?.customComponent;

//   const shouldShowField = (field) => {
//     if (!field.show_when) return true;
//     const { field: dependsOn, equals } = field.show_when;
//     return values[dependsOn] === equals;
//   };

//   // ✅ FIX #1: Check if field has a valid value (not empty, not placeholder)
//   const hasValidValue = (field) => {
//     const value = values[field.name];

//     // Check if value exists and is not empty
//     if (!value || value === '' || value === null || value === undefined) {
//       return false;
//     }

//     // For dropdowns, check if it's not a placeholder value
//     if (field.type === 'dropdown' || field.type === 'select') {
//       // Common placeholder patterns to exclude
//       const placeholderPatterns = [
//         /^select/i,
//         /^choose/i,
//         /^pick/i,
//         /^--/,
//         /^\s*$/
//       ];

//       const stringValue = String(value).trim();
//       return !placeholderPatterns.some(pattern => pattern.test(stringValue));
//     }

//     return true;
//   };

//   const getFields = () => {
//     if (!activeSection) return [];
//     if (activeSection.subTabs?.length) {
//       return (
//         activeSection.subTabs.find((t) => t.id === activeSubTabId)?.fields || []
//       );
//     }
//     return activeSection.fields || [];
//   };

//   const getVisibleFields = (fields) => {
//     return fields.filter((f) => shouldShowField(f));
//   };

//   // ✅ FIX #1: Updated to use hasValidValue instead of just checking if value exists
//   const getFilled = (fields) => {
//     return fields.filter((f) => shouldShowField(f) && hasValidValue(f)).length;
//   };

//   // ✅ FIX #4: Handle document count for uploaded_documents section
//   const getSectionStats = (section) => {
//     // For uploaded documents section
//     if (section.id === 'uploaded_documents' || section.useCustomRenderer) {
//       const docCount = uploadedDocuments ? uploadedDocuments.length : 0;
//       return {
//         total: docCount, // Show actual document count
//         filled: docCount,
//         isDocumentSection: true
//       };
//     }

//     // Regular field-based sections
//     if (section.subTabs?.length) {
//       const total = section.subTabs.reduce(
//         (sum, tab) => sum + getVisibleFields(tab.fields || []).length,
//         0,
//       );
//       const filled = section.subTabs.reduce(
//         (sum, tab) => sum + getFilled(tab.fields || []),
//         0,
//       );
//       return { total, filled, isDocumentSection: false };
//     }

//     return {
//       total: getVisibleFields(section.fields || []).length,
//       filled: getFilled(section.fields || []),
//       isDocumentSection: false
//     };
//   };

//   const icons = {
//     uploaded_documents: "📄", 
//     personal: "👤",
//     employment: "💼",
//     passport: "🛂",
//     address: "🏠",
//     travel: "✈️",
//     declaration: "📋",
//     additional_info_requested: "📝",
//   };

//   const handleSectionChange = (sectionId) => {
//     setActiveSectionId(sectionId);
//     const section = config.sections.find((s) => s.id === sectionId);
//     setActiveSubTabId(section?.subTabs?.[0]?.id || null);
//   };

//   const handlePrevious = () => {
//     const currentIdx = config.sections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     if (currentIdx > 0) {
//       handleSectionChange(config.sections[currentIdx - 1].id);
//     }
//   };

//   const handleNext = () => {
//     const currentIdx = config.sections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     if (currentIdx < config.sections.length - 1) {
//       if (onSectionNext && mode === "edit") {
//         onSectionNext();
//       }

//       handleSectionChange(config.sections[currentIdx + 1].id);
//     }
//   };

//   const isFirstSection =
//     config.sections.findIndex((s) => s.id === activeSectionId) === 0;

//   const isLastSection =
//     config.sections.findIndex((s) => s.id === activeSectionId) ===
//     config.sections.length - 1;

//   const resolveOptions = (field) => {
//     if (field.options_key && dropdownData[field.options_key]) {
//       return dropdownData[field.options_key].map((v) => ({
//         label: v,
//         value: v,
//       }));
//     }

//     if (field.options) {
//       return field.options.map((opt) =>
//         typeof opt === "string" ? { label: opt, value: opt } : opt
//       );
//     }

//     return [];
//   };

//   const groupFieldsBySection = (fields) => {
//     const groups = {};

//     fields.forEach((field) => {
//       const sectionName = field.section || "General Information";
//       if (!groups[sectionName]) {
//         groups[sectionName] = [];
//       }
//       groups[sectionName].push(field);
//     });

//     return groups;
//   };

//   const visibleFields = getVisibleFields(getFields());
//   const groupedFields = groupFieldsBySection(visibleFields);

//   const renderMainContent = () => {
//     if (usesCustomRenderer && CustomComponent) {
//       return (
//         <div className="p-8">
//           <CustomComponent 
//             uploadedDocuments={uploadedDocuments}  
//             applicationId={applicationId}
//           />
//         </div>
//       );
//     }

//     return (
//       <div className="p-8 max-h-[500px] overflow-y-auto">
//         {Object.entries(groupedFields).map(([sectionName, fields]) => (
//           <div key={sectionName} className="mb-8 last:mb-0">
//             <div className="mb-4 pb-2 border-b border-gray-200">
//               <h3 className="text-base font-semibold text-gray-800">
//                 {sectionName}
//               </h3>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
//               {fields.map((field, index) => {
//                 const isFullWidth =
//                   field.type === "textarea" ||
//                   field.fullWidth ||
//                   field.type === "checkbox";

//                 return (
//                   <div
//                     key={field.name || index}
//                     className={isFullWidth ? "md:col-span-2" : ""}
//                   >
//                     <FieldRenderer
//                       field={{
//                         ...field,
//                         options: resolveOptions(field),
//                       }}
//                       value={values[field.name]}
//                       error={errors[field.name]}
//                       onChange={onChange}
//                       readOnly={readOnly}
//                     />
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         ))}

//         {visibleFields.length === 0 && !usesCustomRenderer && (
//           <div className="text-center py-12 text-gray-500">
//             <p>No fields to display in this section.</p>
//           </div>
//         )}
//       </div>
//     );
//   };

//   // ✅ FIX #2: Sort sections to put additional_info_requested first
//   const sortedSections = [...config.sections].sort((a, b) => {
//     if (a.id === 'additional_info_requested') return -1;
//     if (b.id === 'additional_info_requested') return 1;
//     return 0;
//   });

//   return (
//     <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl">
//       <div className="flex gap-6 p-6 max-w-7xl mx-auto">

//         {/* SIDEBAR */}
//         <aside className="w-64 flex-shrink-0 space-y-3 max-h-[600px] overflow-y-auto pr-2">
//           {/* ✅ FIX #2: Use sortedSections instead of config.sections */}
//           {sortedSections.map((section) => {
//             const { total, filled, isDocumentSection } = getSectionStats(section);
//             const isActive = section.id === activeSectionId;
//             const isDone = total > 0 && filled === total;
//             const percentage = total > 0 ? (filled / total) * 100 : 0;

//             return (
//               <button
//                 key={section.id}
//                 onClick={() => handleSectionChange(section.id)}
//                 disabled={mode === "edit" && !allowNavigation}
//                 className={`w-full p-4 rounded-xl text-left transition-all ${
//                   isActive
//                     ? "bg-white shadow-lg scale-105 border-2 border-blue-500"
//                     : "bg-white/70 hover:bg-white hover:shadow-md"
//                   } ${mode === "edit" && !allowNavigation ? "cursor-default" : ""}`}
//               >
//                 <div className="flex items-center gap-3 mb-3">
//                   <span className="text-3xl flex-shrink-0">
//                     {icons[section.id] || "📄"}
//                   </span>
//                   <div className="flex-1 min-w-0">
//                     {/* ✅ FIX #3: Use text wrapping instead of truncate for long names */}
//                     <h4 className="font-semibold text-sm text-gray-800 break-words leading-tight">
//                       {section.title}
//                     </h4>
//                     <p className="text-xs text-gray-500 mt-1">
//                       {/* ✅ FIX #4: Show document count for document sections */}
//                       {isDocumentSection 
//                         ? `${total} document${total !== 1 ? 's' : ''}`
//                         : `${filled}/${total} fields`
//                       }
//                     </p>
//                   </div>
//                   {isDone && (
//                     <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" />
//                   )}
//                 </div>

//                 <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
//                   <div
//                     className="h-full bg-blue-500 rounded-full transition-all duration-500"
//                     style={{ width: `${percentage}%` }}
//                   />
//                 </div>
//               </button>
//             );
//           })}
//         </aside>

//         {/* FORM AREA */}
//         <main className="flex-1 min-w-0">
//           <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

//             {!usesCustomRenderer && activeSection?.subTabs && activeSection.subTabs.length > 0 && (
//               <div className="border-b bg-gray-50 px-6 pt-4">
//                 <div className="flex gap-2 overflow-x-auto pb-0">
//                   {activeSection.subTabs.map((tab) => {
//                     const visibleTabFields = getVisibleFields(tab.fields || []);
//                     const filled = getFilled(tab.fields || []);
//                     const total = visibleTabFields.length;
//                     const active = tab.id === activeSubTabId;
//                     const isComplete = filled === total && total > 0;

//                     return (
//                       <button
//                         key={tab.id}
//                         onClick={() => setActiveSubTabId(tab.id)}
//                         className={`px-6 py-3 rounded-t-lg font-medium text-sm transition-all whitespace-nowrap ${
//                           active
//                             ? "bg-white text-blue-600 border-t-2 border-x-2 border-blue-600"
//                             : "text-gray-600 hover:bg-white/50"
//                           }`}
//                       >
//                         <div className="flex items-center gap-2">
//                           <span>{tab.title}</span>
//                           {isComplete && (
//                             <CheckCircle2 className="w-4 h-4 text-green-500" />
//                           )}
//                         </div>
//                         <div className="text-xs mt-1 opacity-90">
//                           {filled}/{total}
//                         </div>
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}

//             {renderMainContent()}

//             {mode === "edit" && (
//               <div className="border-t bg-gray-50 p-6 flex justify-between items-center">
//                 <button
//                   onClick={handlePrevious}
//                   disabled={isFirstSection}
//                   className={`px-6 py-2.5 rounded-lg font-medium transition-all ${
//                     isFirstSection
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : "bg-white text-gray-700 hover:shadow-md border border-gray-300"
//                     }`}
//                 >
//                   ← Previous
//                 </button>

//                 {!isLastSection && (
//                   <button
//                     onClick={handleNext}
//                     className="px-6 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-md font-medium transition-all flex items-center gap-2"
//                   >
//                     <span>Next Section</span>
//                   </button>
//                 )}
//               </div>
//             )}

//             {(mode === "review" || mode === "view") && (
//               <div className="border-t bg-gray-50 p-6 text-center">
//                 {/* Review mode info */}
//               </div>
//             )}
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// }


// --------------this is working -------

// function PassengerFormTabs({
//   config,
//   values,
//   errors,
//   onChange,
//   onSectionNext,
//   dropdownData,
//   readOnly = false,
//   allowNavigation = false,
//   mode = "edit",
//   uploadedDocuments = [],
//   applicationId,
// }) {

//   const [activeSectionId, setActiveSectionId] = useState(null);
//   const [activeSubTabId, setActiveSubTabId] = useState(null);


//   // ✅ NEW: Smart default section selection
//   useEffect(() => {
//     if (config?.sections?.length) {
//       // Check if additional_info_requested section exists
//       const additionalInfoSection = config.sections.find(
//         s => s.id === 'additional_info_requested'
//       );

//       // If additional info section exists, open it by default
//       if (additionalInfoSection) {
//         setActiveSectionId(additionalInfoSection.id);
//         setActiveSubTabId(additionalInfoSection.subTabs?.[0]?.id || null);
//       } else {
//         // Otherwise, open the first section (or personal section if it exists)
//         const personalSection = config.sections.find(s => s.id === 'personal');
//         const defaultSection = personalSection || config.sections[0];

//         setActiveSectionId(defaultSection.id);
//         setActiveSubTabId(defaultSection.subTabs?.[0]?.id || null);
//       }
//     }
//   }, [config]);

//   if (!config || !config.sections) {
//     return <p className="text-gray-500">No form configuration available.</p>;
//   }

//   const activeSection = config.sections.find((s) => s.id === activeSectionId);
//   const usesCustomRenderer = activeSection?.useCustomRenderer;
//   const CustomComponent = activeSection?.customComponent;

//   const shouldShowField = (field) => {
//     if (!field.show_when) return true;
//     const { field: dependsOn, equals } = field.show_when;
//     return values[dependsOn] === equals;
//   };

//   const hasValidValue = (field) => {
//     const value = values[field.name];

//     if (!value || value === '' || value === null || value === undefined) {
//       return false;
//     }

//     if (field.type === 'dropdown' || field.type === 'select') {
//       const placeholderPatterns = [
//         /^select/i,
//         /^choose/i,
//         /^pick/i,
//         /^--/,
//         /^\s*$/
//       ];

//       const stringValue = String(value).trim();
//       return !placeholderPatterns.some(pattern => pattern.test(stringValue));
//     }

//     return true;
//   };

//   const getFields = () => {
//     if (!activeSection) return [];
//     if (activeSection.subTabs?.length) {
//       return (
//         activeSection.subTabs.find((t) => t.id === activeSubTabId)?.fields || []
//       );
//     }
//     return activeSection.fields || [];
//   };

//   const getVisibleFields = (fields) => {
//     return fields.filter((f) => shouldShowField(f));
//   };

//   const getFilled = (fields) => {
//     return fields.filter((f) => shouldShowField(f) && hasValidValue(f)).length;
//   };

//   const getSectionStats = (section) => {
//     if (section.id === 'uploaded_documents' || section.useCustomRenderer) {
//       const docCount = uploadedDocuments ? uploadedDocuments.length : 0;
//       return {
//         total: docCount,
//         filled: docCount,
//         isDocumentSection: true
//       };
//     }

//     if (section.subTabs?.length) {
//       const total = section.subTabs.reduce(
//         (sum, tab) => sum + getVisibleFields(tab.fields || []).length,
//         0,
//       );
//       const filled = section.subTabs.reduce(
//         (sum, tab) => sum + getFilled(tab.fields || []),
//         0,
//       );
//       return { total, filled, isDocumentSection: false };
//     }

//     return {
//       total: getVisibleFields(section.fields || []).length,
//       filled: getFilled(section.fields || []),
//       isDocumentSection: false
//     };
//   };

//   const icons = {
//     uploaded_documents: "📄",
//     personal: "👤",
//     employment: "💼",
//     passport: "🛂",
//     address: "🏠",
//     travel: "✈️",
//     declaration: "📋",
//     additional_info_requested: "📝",
//   };

//   const handleSectionChange = (sectionId) => {
//     setActiveSectionId(sectionId);
//     const section = config.sections.find((s) => s.id === sectionId);
//     setActiveSubTabId(section?.subTabs?.[0]?.id || null);
//   };

//   const handlePrevious = () => {
//     const currentIdx = config.sections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     if (currentIdx > 0) {
//       handleSectionChange(config.sections[currentIdx - 1].id);
//     }
//   };

//   const handleNext = () => {
//     const currentIdx = config.sections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     if (currentIdx < config.sections.length - 1) {
//       if (onSectionNext && mode === "edit") {
//         onSectionNext();
//       }

//       handleSectionChange(config.sections[currentIdx + 1].id);
//     }
//   };

//   const isFirstSection =
//     config.sections.findIndex((s) => s.id === activeSectionId) === 0;

//   const isLastSection =
//     config.sections.findIndex((s) => s.id === activeSectionId) ===
//     config.sections.length - 1;

//   const resolveOptions = (field) => {
//     if (field.options_key && dropdownData[field.options_key]) {
//       return dropdownData[field.options_key].map((v) => ({
//         label: v,
//         value: v,
//       }));
//     }

//     if (field.options) {
//       return field.options.map((opt) =>
//         typeof opt === "string" ? { label: opt, value: opt } : opt
//       );
//     }

//     return [];
//   };

//   const groupFieldsBySection = (fields) => {
//     const groups = {};

//     fields.forEach((field) => {
//       const sectionName = field.section || "General Information";
//       if (!groups[sectionName]) {
//         groups[sectionName] = [];
//       }
//       groups[sectionName].push(field);
//     });

//     return groups;
//   };

//   const visibleFields = getVisibleFields(getFields());
//   const groupedFields = groupFieldsBySection(visibleFields);

//   const renderMainContent = () => {
//     if (usesCustomRenderer && CustomComponent) {
//       return (
//         <div className="p-8">
//           <CustomComponent
//             uploadedDocuments={uploadedDocuments}
//             applicationId={applicationId}
//           />
//         </div>
//       );
//     }

//     return (
//       <div className="p-8 max-h-[500px] overflow-y-auto">
//         {Object.entries(groupedFields).map(([sectionName, fields]) => (
//           <div key={sectionName} className="mb-8 last:mb-0">
//             <div className="mb-4 pb-2 border-b border-gray-200">
//               <h3 className="text-base font-semibold text-gray-800">
//                 {sectionName}
//               </h3>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
//               {fields.map((field, index) => {
//                 const isFullWidth =
//                   field.type === "textarea" ||
//                   field.fullWidth ||
//                   field.type === "checkbox";

//                 return (
//                   <div
//                     key={field.name || index}
//                     className={isFullWidth ? "md:col-span-2" : ""}
//                   >
//                     <FieldRenderer
//                       field={{
//                         ...field,
//                         options: resolveOptions(field),
//                       }}
//                       value={values[field.name]}
//                       error={errors[field.name]}
//                       onChange={onChange}
//                       readOnly={readOnly}
//                     />
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         ))}

//         {visibleFields.length === 0 && !usesCustomRenderer && (
//           <div className="text-center py-12 text-gray-500">
//             <p>No fields to display in this section.</p>
//           </div>
//         )}
//       </div>
//     );
//   };

//   const sortedSections = [...config.sections].sort((a, b) => {
//     if (a.id === 'additional_info_requested') return -1;
//     if (b.id === 'additional_info_requested') return 1;
//     return 0;
//   });

//   return (
//     <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl">
//       <div className="flex gap-6 p-6 max-w-7xl mx-auto">

//         {/* SIDEBAR */}
//         <aside className="w-72 flex-shrink-0 space-y-3 max-h-[600px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
//           {sortedSections.map((section) => {
//             const { total, filled, isDocumentSection } = getSectionStats(section);
//             const isActive = section.id === activeSectionId;
//             const isDone = total > 0 && filled === total;
//             const percentage = total > 0 ? (filled / total) * 100 : 0;

//             return (
//               <button
//                 key={section.id}
//                 onClick={() => handleSectionChange(section.id)}
//                 disabled={mode === "edit" && !allowNavigation}
//                 className={`w-full p-3.5 rounded-xl text-left transition-all duration-200 ${isActive
//                     ? "bg-white shadow-lg border-2 border-blue-500"
//                     : "bg-white/70 hover:bg-white hover:shadow-md hover:scale-[1.02]"
//                   } ${mode === "edit" && !allowNavigation ? "cursor-default" : "cursor-pointer"}`}
//               >
//                 <div className="flex items-start gap-3 mb-2.5">
//                   <span className="text-2xl flex-shrink-0 mt-0.5">
//                     {icons[section.id] || "📄"}
//                   </span>
//                   <div className="flex-1 min-w-0 overflow-hidden">
//                     <h4 className="font-semibold text-sm text-gray-800 leading-snug mb-1">
//                       {section.title}
//                     </h4>
//                     <p className="text-xs text-gray-500">
//                       {isDocumentSection
//                         ? `${total} document${total !== 1 ? 's' : ''}`
//                         : `${filled}/${total} fields`
//                       }
//                     </p>
//                   </div>
//                   {isDone && (
//                     <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
//                   )}
//                 </div>

//                 <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
//                   <div
//                     className="h-full bg-blue-500 rounded-full transition-all duration-500 ease-out"
//                     style={{ width: `${percentage}%` }}
//                   />
//                 </div>
//               </button>
//             );
//           })}
//         </aside>
//         {/* FORM AREA */}
//         <main className="flex-1 min-w-0">
//           <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

//             {!usesCustomRenderer && activeSection?.subTabs && activeSection.subTabs.length > 0 && (
//               <div className="border-b bg-gray-50 px-6 pt-4">
//                 <div className="flex gap-2 overflow-x-auto pb-0">
//                   {activeSection.subTabs.map((tab) => {
//                     const visibleTabFields = getVisibleFields(tab.fields || []);
//                     const filled = getFilled(tab.fields || []);
//                     const total = visibleTabFields.length;
//                     const active = tab.id === activeSubTabId;
//                     const isComplete = filled === total && total > 0;

//                     return (
//                       <button
//                         key={tab.id}
//                         onClick={() => setActiveSubTabId(tab.id)}
//                         className={`px-6 py-3 rounded-t-lg font-medium text-sm transition-all whitespace-nowrap ${active
//                             ? "bg-white text-blue-600 border-t-2 border-x-2 border-blue-600"
//                             : "text-gray-600 hover:bg-white/50"
//                           }`}
//                       >
//                         <div className="flex items-center gap-2">
//                           <span>{tab.title}</span>
//                           {isComplete && (
//                             <CheckCircle2 className="w-4 h-4 text-green-500" />
//                           )}
//                         </div>
//                         <div className="text-xs mt-1 opacity-90">
//                           {filled}/{total}
//                         </div>
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}

//             {renderMainContent()}

//             {mode === "edit" && (
//               <div className="border-t bg-gray-50 p-6 flex justify-between items-center">
//                 <button
//                   onClick={handlePrevious}
//                   disabled={isFirstSection}
//                   className={`px-6 py-2.5 rounded-lg font-medium transition-all ${isFirstSection
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : "bg-white text-gray-700 hover:shadow-md border border-gray-300"
//                     }`}
//                 >
//                   ← Previous
//                 </button>

//                 {!isLastSection && (
//                   <button
//                     onClick={handleNext}
//                     className="px-6 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-md font-medium transition-all flex items-center gap-2"
//                   >
//                     <span>Next Section</span>
//                   </button>
//                 )}
//               </div>
//             )}

//             {(mode === "review" || mode === "view") && (
//               <div className="border-t bg-gray-50 p-6 text-center">
//                 {/* Review mode info */}
//               </div>
//             )}
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// }



// ---------------------


// function PassengerFormTabs({
//   config,
//   values,
//   errors,
//   onChange,
//   onSectionNext,
//   dropdownData,
//   readOnly = false,
//   allowNavigation = false,
//   mode = "edit",
//   uploadedDocuments = [],
//   applicationId,
//   saarcVisits,
//   onAddSaarcVisit,
//   onRemoveSaarcVisit,
//   onSaarcVisitChange,
// }) {

//   const [activeSectionId, setActiveSectionId] = useState(null);
//   const [activeSubTabId, setActiveSubTabId] = useState(null);

//   console.log("Values", values);

//   // ✅ NEW: Smart default section selection
//   useEffect(() => {
//     if (config?.sections?.length) {
//       // Check if additional_info_requested section exists
//       const additionalInfoSection = config.sections.find(
//         s => s.id === 'additional_info_requested'
//       );

//       // If additional info section exists, open it by default
//       if (additionalInfoSection) {
//         setActiveSectionId(additionalInfoSection.id);
//         setActiveSubTabId(additionalInfoSection.subTabs?.[0]?.id || null);
//       } else {
//         // Otherwise, open the first section (or personal section if it exists)
//         const personalSection = config.sections.find(s => s.id === 'personal');
//         const defaultSection = personalSection || config.sections[0];

//         setActiveSectionId(defaultSection.id);
//         setActiveSubTabId(defaultSection.subTabs?.[0]?.id || null);
//       }
//     }
//   }, [config]);

//   if (!config || !config.sections) {
//     return <p className="text-gray-500">No form configuration available.</p>;
//   }

//   const activeSection = config.sections.find((s) => s.id === activeSectionId);
//   const usesCustomRenderer = activeSection?.useCustomRenderer;
//   const CustomComponent = activeSection?.customComponent;

//   const shouldShowField = (field) => {
//     if (!field.show_when) return true;
//     const { field: dependsOn, equals } = field.show_when;
//     return values[dependsOn] === equals;
//   };

//   const hasValidValue = (field) => {
//     const value = values[field.name];

//     if (!value || value === '' || value === null || value === undefined) {
//       return false;
//     }

//     if (field.type === 'dropdown' || field.type === 'select') {
//       const placeholderPatterns = [
//         /^select/i,
//         /^choose/i,
//         /^pick/i,
//         /^--/,
//         /^\s*$/
//       ];

//       const stringValue = String(value).trim();
//       return !placeholderPatterns.some(pattern => pattern.test(stringValue));
//     }

//     return true;
//   };

//   const getFields = () => {
//     if (!activeSection) return [];
//     if (activeSection.subTabs?.length) {
//       return (
//         activeSection.subTabs.find((t) => t.id === activeSubTabId)?.fields || []
//       );
//     }
//     return activeSection.fields || [];
//   };

//   const getVisibleFields = (fields) => {
//     return fields.filter((f) => shouldShowField(f));
//   };

//   const getFilled = (fields) => {
//     return fields.filter((f) => shouldShowField(f) && hasValidValue(f)).length;
//   };

//   const getSectionStats = (section) => {
//     if (section.id === 'uploaded_documents' || section.useCustomRenderer) {
//       const docCount = uploadedDocuments ? uploadedDocuments.length : 0;
//       return {
//         total: docCount,
//         filled: docCount,
//         isDocumentSection: true
//       };
//     }

//     if (section.subTabs?.length) {
//       const total = section.subTabs.reduce(
//         (sum, tab) => sum + getVisibleFields(tab.fields || []).length,
//         0,
//       );
//       const filled = section.subTabs.reduce(
//         (sum, tab) => sum + getFilled(tab.fields || []),
//         0,
//       );
//       return { total, filled, isDocumentSection: false };
//     }

//     return {
//       total: getVisibleFields(section.fields || []).length,
//       filled: getFilled(section.fields || []),
//       isDocumentSection: false
//     };
//   };

//   const icons = {
//     uploaded_documents: "📄",
//     personal: "👤",
//     employment: "💼",
//     passport: "🛂",
//     address: "🏠",
//     travel: "✈️",
//     declaration: "📋",
//     additional_info_requested: "📝",
//   };

//   const handleSectionChange = (sectionId) => {
//     setActiveSectionId(sectionId);
//     const section = config.sections.find((s) => s.id === sectionId);
//     setActiveSubTabId(section?.subTabs?.[0]?.id || null);
//   };

//   const handlePrevious = () => {
//     const currentIdx = config.sections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     if (currentIdx > 0) {
//       handleSectionChange(config.sections[currentIdx - 1].id);
//     }
//   };

//   const handleNext = () => {
//     const currentIdx = config.sections.findIndex(
//       (s) => s.id === activeSectionId,
//     );

//     if (currentIdx < config.sections.length - 1) {
//       if (onSectionNext && mode === "edit") {
//         onSectionNext();
//       }

//       handleSectionChange(config.sections[currentIdx + 1].id);
//     }
//   };

//   const isFirstSection =
//     config.sections.findIndex((s) => s.id === activeSectionId) === 0;

//   const isLastSection =
//     config.sections.findIndex((s) => s.id === activeSectionId) ===
//     config.sections.length - 1;

//   const resolveOptions = (field) => {
//     if (field.options_key && dropdownData[field.options_key]) {
//       return dropdownData[field.options_key].map((v) => ({
//         label: v,
//         value: v,
//       }));
//     }

//     if (field.options) {
//       return field.options.map((opt) =>
//         typeof opt === "string" ? { label: opt, value: opt } : opt
//       );
//     }

//     return [];
//   };

//   const groupFieldsBySection = (fields) => {
//     const groups = {};

//     fields.forEach((field) => {
//       const sectionName = field.section || "General Information";
//       if (!groups[sectionName]) {
//         groups[sectionName] = [];
//       }
//       groups[sectionName].push(field);
//     });

//     return groups;
//   };

//   const visibleFields = getVisibleFields(getFields());
//   const groupedFields = groupFieldsBySection(visibleFields);

//   // ✅ NEW: Render custom SAARC visits component
//  const renderSaarcVisits = () => {
//   const showSaarc = values.saarc_visit === "YES";
//   if (!showSaarc) return null;

//   return (
//     <div className="md:col-span-2 space-y-4">
//       {saarcVisits.map((visit, index) => (
//         <div
//           key={visit.id}
//           className="relative border border-gray-200 rounded-lg p-6 bg-gray-50"
//         >
//           {/* Remove button - only show if more than one entry */}
//           {saarcVisits.length > 1 && !readOnly && (
//             <button
//               type="button"
//               onClick={() => onRemoveSaarcVisit(visit.id)}
//               className="absolute top-4 right-4 text-red-500 hover:text-red-700 transition-colors"
//               title="Remove this visit"
//             >
//               <svg 
//                 xmlns="http://www.w3.org/2000/svg" 
//                 width="20" 
//                 height="20" 
//                 viewBox="0 0 24 24" 
//                 fill="none" 
//                 stroke="currentColor" 
//                 strokeWidth="2" 
//                 strokeLinecap="round" 
//                 strokeLinejoin="round"
//               >
//                 <path d="M3 6h18"/>
//                 <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
//                 <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
//               </svg>
//             </button>
//           )}

//           <h4 className="text-sm font-semibold text-gray-700 mb-4">
//             SAARC Visit #{index + 1}
//           </h4>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {/* SAARC Country */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 SAARC Country
//               </label>
//               <select
//                 value={visit.saarc_country}
//                 onChange={(e) =>
//                   onSaarcVisitChange(visit.id, "saarc_country", e.target.value)
//                 }
//                 disabled={readOnly}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
//               >
//                 <option value="">Select SAARC Country</option>
//                 {(MASTER_DATA.saarc_country || []).map((country) => (
//                   <option key={country.value} value={country.value}>
//                     {country.label}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Year */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Year
//               </label>
//               <input
//                 type="text"
//                 value={visit.saarc_year}
//                 onChange={(e) =>
//                   onSaarcVisitChange(visit.id, "saarc_year", e.target.value)
//                 }
//                 disabled={readOnly}
//                 placeholder="e.g., 2023"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
//               />
//             </div>

//             {/* Number of Visits */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Number of Visits
//               </label>
//               <input
//                 type="text"
//                 value={visit.no_of_visits}
//                 onChange={(e) =>
//                   onSaarcVisitChange(visit.id, "no_of_visits", e.target.value)
//                 }
//                 disabled={readOnly}
//                 placeholder="e.g., 2"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
//               />
//             </div>
//           </div>
//         </div>
//       ))}

//       {/* Add Another Visit Button */}
//       {!readOnly && (
//         <button
//           type="button"
//           onClick={onAddSaarcVisit}
//           className="flex items-center gap-2 px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
//         >
//           <svg 
//             xmlns="http://www.w3.org/2000/svg" 
//             width="18" 
//             height="18" 
//             viewBox="0 0 24 24" 
//             fill="none" 
//             stroke="currentColor" 
//             strokeWidth="2" 
//             strokeLinecap="round" 
//             strokeLinejoin="round"
//           >
//             <line x1="12" y1="5" x2="12" y2="19"/>
//             <line x1="5" y1="12" x2="19" y2="12"/>
//           </svg>
//           Add Another SAARC Visit
//         </button>
//       )}
//     </div>
//   );
// };

//   const renderMainContent = () => {
//     if (usesCustomRenderer && CustomComponent) {
//       return (
//         <div className="p-8">
//           <CustomComponent
//             uploadedDocuments={uploadedDocuments}
//             applicationId={applicationId}
//           />
//         </div>
//       );
//     }

//     return (
//       <div className="p-8 max-h-[500px] overflow-y-auto">
//         {Object.entries(groupedFields).map(([sectionName, fields]) => (
//           <div key={sectionName} className="mb-8 last:mb-0">
//             <div className="mb-4 pb-2 border-b border-gray-200">
//               <h3 className="text-base font-semibold text-gray-800">
//                 {sectionName}
//               </h3>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
//               {fields.map((field, index) => {
//                 const isFullWidth =
//                   field.type === "textarea" ||
//                   field.fullWidth ||
//                   field.type === "checkbox";

//                 // ✅ Check if this is the SAARC visit trigger field
//                 const isSaarcTrigger = field.name === "saarc_visit";

//                 return (
//                   <React.Fragment key={field.name || index}>
//                     <div className={isFullWidth ? "md:col-span-2" : ""}>
//                       <FieldRenderer
//                         field={{
//                           ...field,
//                           options: resolveOptions(field),
//                         }}
//                         value={values[field.name]}
//                         error={errors[field.name]}
//                         onChange={onChange}
//                         readOnly={readOnly}
//                       />
//                     </div>

//                     {/* ✅ Render SAARC visits component right after the trigger field */}
//                     {isSaarcTrigger && renderSaarcVisits()}
//                   </React.Fragment>
//                 );
//               })}
//             </div>
//           </div>
//         ))}

//         {visibleFields.length === 0 && !usesCustomRenderer && (
//           <div className="text-center py-12 text-gray-500">
//             <p>No fields to display in this section.</p>
//           </div>
//         )}
//       </div>
//     );
//   };

//   const sortedSections = [...config.sections].sort((a, b) => {
//     if (a.id === 'additional_info_requested') return -1;
//     if (b.id === 'additional_info_requested') return 1;
//     return 0;
//   });

//   return (
//     <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl">
//       <div className="flex gap-6 p-6 max-w-7xl mx-auto">

//         {/* SIDEBAR */}
//         <aside className="w-72 flex-shrink-0 space-y-3 max-h-[600px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
//           {sortedSections.map((section) => {
//             const { total, filled, isDocumentSection } = getSectionStats(section);
//             const isActive = section.id === activeSectionId;
//             const isDone = total > 0 && filled === total;
//             const percentage = total > 0 ? (filled / total) * 100 : 0;

//             return (
//               <button
//                 key={section.id}
//                 onClick={() => handleSectionChange(section.id)}
//                 disabled={mode === "edit" && !allowNavigation}
//                 className={`w-full p-3.5 rounded-xl text-left transition-all duration-200 ${isActive
//                     ? "bg-white shadow-lg border-2 border-blue-500"
//                     : "bg-white/70 hover:bg-white hover:shadow-md hover:scale-[1.02]"
//                   } ${mode === "edit" && !allowNavigation ? "cursor-default" : "cursor-pointer"}`}
//               >
//                 <div className="flex items-start gap-3 mb-2.5">
//                   <span className="text-2xl flex-shrink-0 mt-0.5">
//                     {icons[section.id] || "📄"}
//                   </span>
//                   <div className="flex-1 min-w-0 overflow-hidden">
//                     <h4 className="font-semibold text-sm text-gray-800 leading-snug mb-1">
//                       {section.title}
//                     </h4>
//                     <p className="text-xs text-gray-500">
//                       {isDocumentSection
//                         ? `${total} document${total !== 1 ? 's' : ''}`
//                         : `${filled}/${total} fields`
//                       }
//                     </p>
//                   </div>
//                   {isDone && (
//                     <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
//                   )}
//                 </div>

//                 <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
//                   <div
//                     className="h-full bg-blue-500 rounded-full transition-all duration-500 ease-out"
//                     style={{ width: `${percentage}%` }}
//                   />
//                 </div>
//               </button>
//             );
//           })}
//         </aside>


//         {/* FORM AREA */}
//         <main className="flex-1 min-w-0">
//           <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

//             {!usesCustomRenderer && activeSection?.subTabs && activeSection.subTabs.length > 0 && (
//               <div className="border-b bg-gray-50 px-6 pt-4">
//                 <div className="flex gap-2 overflow-x-auto pb-0">
//                   {activeSection.subTabs.map((tab) => {
//                     const visibleTabFields = getVisibleFields(tab.fields || []);
//                     const filled = getFilled(tab.fields || []);
//                     const total = visibleTabFields.length;
//                     const active = tab.id === activeSubTabId;
//                     const isComplete = filled === total && total > 0;

//                     return (
//                       <button
//                         key={tab.id}
//                         onClick={() => setActiveSubTabId(tab.id)}
//                         className={`px-6 py-3 rounded-t-lg font-medium text-sm transition-all whitespace-nowrap ${active
//                             ? "bg-white text-blue-600 border-t-2 border-x-2 border-blue-600"
//                             : "text-gray-600 hover:bg-white/50"
//                           }`}
//                       >
//                         <div className="flex items-center gap-2">
//                           <span>{tab.title}</span>
//                           {isComplete && (
//                             <CheckCircle2 className="w-4 h-4 text-green-500" />
//                           )}
//                         </div>
//                         <div className="text-xs mt-1 opacity-90">
//                           {filled}/{total}
//                         </div>
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}

//             {renderMainContent()}

//             {mode === "edit" && (
//               <div className="border-t bg-gray-50 p-6 flex justify-between items-center">
//                 <button
//                   onClick={handlePrevious}
//                   disabled={isFirstSection}
//                   className={`px-6 py-2.5 rounded-lg font-medium transition-all ${isFirstSection
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : "bg-white text-gray-700 hover:shadow-md border border-gray-300"
//                     }`}
//                 >
//                   ← Previous
//                 </button>

//                 {!isLastSection && (
//                   <button
//                     onClick={handleNext}
//                     className="px-6 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-md font-medium transition-all flex items-center gap-2"
//                   >
//                     <span>Next Section</span>
//                   </button>
//                 )}
//               </div>
//             )}

//             {(mode === "review" || mode === "view") && (
//               <div className="border-t bg-gray-50 p-6 text-center">
//                 {/* Review mode info */}
//               </div>
//             )}
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// }


function PassengerFormTabs({
  config,
  values,
  errors,
  onChange,
  onSectionNext,
  dropdownData,
  readOnly = false,
  allowNavigation = false,
  mode = "edit",
  uploadedDocuments = [],
  applicationId,
  saarcVisits,
  onAddSaarcVisit,
  onRemoveSaarcVisit,
  onSaarcVisitChange,
  additionalInfoRounds = [], // ✅ ADD THIS PROP
  onAdditionalInfoUpdate, // ✅ ADD THIS PROP
}) {

  const [activeSectionId, setActiveSectionId] = useState(null);
  const [activeSubTabId, setActiveSubTabId] = useState(null);
  const [completedSections, setCompletedSections] = useState([]); // Track completed sections
  // ✅ ADD THIS: Ref for the main form area
  const mainFormRef = useRef(null);
 

  // ✅ HELPER FUNCTION: Scroll to top of form
  const scrollToTop = () => {
    // Try multiple methods to ensure scrolling works
    if (mainFormRef.current) {
      // Scroll the main form container
      mainFormRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    // Also scroll the window to the top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // ✅ NEW: Smart default section selection
  useEffect(() => {
    if (config?.sections?.length) {
      // Check if additional_info_requested section exists
      const additionalInfoSection = config.sections.find(
        s => s.id === 'additional_info_requested'
      );

      // If additional info section exists, open it by default
      if (additionalInfoSection) {
        setActiveSectionId(additionalInfoSection.id);
        setActiveSubTabId(additionalInfoSection.subTabs?.[0]?.id || null);
      } else {
        // Otherwise, open the first section (or personal section if it exists)
        const personalSection = config.sections.find(s => s.id === 'personal');
        const defaultSection = personalSection || config.sections[0];

        setActiveSectionId(defaultSection.id);
        setActiveSubTabId(defaultSection.subTabs?.[0]?.id || null);
      }
    }
  }, [config]);

  if (!config || !config.sections) {
    return <p className="text-gray-500">No form configuration available.</p>;
  }

  const activeSection = config.sections.find((s) => s.id === activeSectionId);
  const usesCustomRenderer = activeSection?.useCustomRenderer;
  const CustomComponent = activeSection?.customComponent;

  const shouldShowField = (field) => {
    if (!field.show_when) return true;
    const { field: dependsOn, equals } = field.show_when;
    return values[dependsOn] === equals;
  };

  const hasValidValue = (field) => {
    const value = values[field.name];

    if (!value || value === '' || value === null || value === undefined) {
      return false;
    }

    if (field.type === 'dropdown' || field.type === 'select') {
      const placeholderPatterns = [
        /^select/i,
        /^choose/i,
        /^pick/i,
        /^--/,
        /^\s*$/
      ];

      const stringValue = String(value).trim();
      return !placeholderPatterns.some(pattern => pattern.test(stringValue));
    }

    return true;
  };

  const getFields = () => {
    if (!activeSection) return [];
    if (activeSection.subTabs?.length) {
      return (
        activeSection.subTabs.find((t) => t.id === activeSubTabId)?.fields || []
      );
    }
    return activeSection.fields || [];
  };

  const getVisibleFields = (fields) => {
    return fields.filter((f) => shouldShowField(f));
  };

  const getFilled = (fields) => {
    return fields.filter((f) => shouldShowField(f) && hasValidValue(f)).length;
  };

  // const getSectionStats = (section) => {
  //   if (section.id === 'uploaded_documents' || section.useCustomRenderer) {
  //     const docCount = uploadedDocuments ? uploadedDocuments.length : 0;
  //     return {
  //       total: docCount,
  //       filled: docCount,
  //       isDocumentSection: true
  //     };
  //   }

  //   if (section.subTabs?.length) {
  //     const total = section.subTabs.reduce(
  //       (sum, tab) => sum + getVisibleFields(tab.fields || []).length,
  //       0,
  //     );
  //     const filled = section.subTabs.reduce(
  //       (sum, tab) => sum + getFilled(tab.fields || []),
  //       0,
  //     );
  //     return { total, filled, isDocumentSection: false };
  //   }

  //   return {
  //     total: getVisibleFields(section.fields || []).length,
  //     filled: getFilled(section.fields || []),
  //     isDocumentSection: false
  //   };
  // };

 
 const getSectionStats = (section) => {
    // Handle uploaded_documents section
    if (section.id === 'uploaded_documents') {
      const docCount = uploadedDocuments ? uploadedDocuments.length : 0;
      return {
        total: docCount,
        filled: docCount,
        isDocumentSection: true
      };
    }

    // ✅ Handle additional_info_requested section
    if (section.id === 'additional_info_requested') {
      // Get all pending rounds
      const pendingRounds = additionalInfoRounds.filter(r => 
        ["open", "pending"].includes(String(r.status).toLowerCase())
      );

      // Count total fields across all pending rounds
      const totalFields = pendingRounds.reduce((sum, round) => {
        return sum + (round.fields?.length || 0);
      }, 0);

      // Count completed fields (fields that have responses)
      const filledFields = pendingRounds.reduce((sum, round) => {
        if (!round.user_response) return sum;
        
        const completedCount = (round.fields || []).filter(field => {
          const response = round.user_response[field.key];
          return response && response !== '';
        }).length;
        
        return sum + completedCount;
      }, 0);

      return {
        total: totalFields,
        filled: filledFields,
        isDocumentSection: false
      };
    }

    // Handle other custom renderer sections
    if (section.useCustomRenderer) {
      return {
        total: 0,
        filled: 0,
        isDocumentSection: false
      };
    }

    // Handle regular sections with subtabs
    if (section.subTabs?.length) {
      const total = section.subTabs.reduce(
        (sum, tab) => sum + getVisibleFields(tab.fields || []).length,
        0,
      );
      const filled = section.subTabs.reduce(
        (sum, tab) => sum + getFilled(tab.fields || []),
        0,
      );
      return { total, filled, isDocumentSection: false };
    }

    // Handle regular sections with fields
    return {
      total: getVisibleFields(section.fields || []).length,
      filled: getFilled(section.fields || []),
      isDocumentSection: false
    };
  };


  const icons = {
    uploaded_documents: "📄",
    personal: "👤",
    employment: "💼",
    passport: "🛂",
    address: "🏠",
    travel: "✈️",
    declaration: "📋",
    additional_info_requested: "📝",
  };

  const handleSectionChange = (sectionId) => {
    setActiveSectionId(sectionId);
    const section = config.sections.find((s) => s.id === sectionId);
    setActiveSubTabId(section?.subTabs?.[0]?.id || null);

    // ✅ Scroll after state updates
    setTimeout(() => scrollToTop(), 0);
  };

  const handlePrevious = () => {
    const currentSection = activeSection;

    // If there are subtabs, check if we can go to previous subtab
    if (currentSection?.subTabs?.length > 0) {
      const currentSubTabIndex = currentSection.subTabs.findIndex(
        (t) => t.id === activeSubTabId
      );

      // If not on first subtab, go to previous subtab
      if (currentSubTabIndex > 0) {
        setActiveSubTabId(currentSection.subTabs[currentSubTabIndex - 1].id);
        // ✅ Scroll after state updates
        setTimeout(() => scrollToTop(), 0);
        return;
      }
    }

    // Otherwise, go to previous section
    const currentIdx = config.sections.findIndex(
      (s) => s.id === activeSectionId
    );

    if (currentIdx > 0) {
      const prevSection = config.sections[currentIdx - 1];
      setActiveSectionId(prevSection.id);

      // If previous section has subtabs, go to the LAST subtab
      if (prevSection.subTabs?.length > 0) {
        setActiveSubTabId(prevSection.subTabs[prevSection.subTabs.length - 1].id);
      } else {
        setActiveSubTabId(null);
      }
      // ✅ Scroll after state updates
      setTimeout(() => scrollToTop(), 0);
    }
  };

  // ✅ UPDATED: Handle Next - navigate through subtabs first, then sections
  const handleNext = () => {
    const currentSection = activeSection;

    // If there are subtabs, check if we can go to next subtab
    if (currentSection?.subTabs?.length > 0) {
      const currentSubTabIndex = currentSection.subTabs.findIndex(
        (t) => t.id === activeSubTabId
      );

      // If not on last subtab, go to next subtab
      if (currentSubTabIndex < currentSection.subTabs.length - 1) {
        setActiveSubTabId(currentSection.subTabs[currentSubTabIndex + 1].id);
        // ✅ Scroll after state updates
        setTimeout(() => scrollToTop(), 0);
        return;
      }
    }

    // If we're on the last subtab (or no subtabs), mark section as completed and move to next section
    const currentIdx = config.sections.findIndex(
      (s) => s.id === activeSectionId
    );

    if (currentIdx < config.sections.length - 1) {
      // Mark current section as completed
      if (!completedSections.includes(activeSectionId)) {
        setCompletedSections([...completedSections, activeSectionId]);
      }

      // Call onSectionNext for progressive save
      if (onSectionNext && mode === "edit") {
        onSectionNext();
      }

      // Move to next section
      const nextSection = config.sections[currentIdx + 1];
      setActiveSectionId(nextSection.id);
      setActiveSubTabId(nextSection.subTabs?.[0]?.id || null);
      // ✅ Scroll after state updates
      setTimeout(() => scrollToTop(), 0);
    }
  };

  // ✅ Check if a section is accessible
  const isSectionAccessible = (sectionIndex) => {
    if (mode === "review" || mode === "view") return true; // All sections accessible in review/view mode
    if (allowNavigation) return true; // If navigation is allowed, all sections accessible

    const currentIdx = config.sections.findIndex(
      (s) => s.id === activeSectionId
    );

    // Current section is always accessible
    if (sectionIndex === currentIdx) return true;

    // Previous completed sections are accessible
    const section = config.sections[sectionIndex];
    if (completedSections.includes(section.id)) return true;

    // First section is always accessible
    if (sectionIndex === 0) return true;

    return false;
  };

  const isFirstSection =
    config.sections.findIndex((s) => s.id === activeSectionId) === 0;

  const isLastSection =
    config.sections.findIndex((s) => s.id === activeSectionId) ===
    config.sections.length - 1;

  // ✅ Check if we're on the first subtab of first section
  const isFirstSubTab = () => {
    if (!activeSection?.subTabs?.length) return isFirstSection;
    const currentSubTabIndex = activeSection.subTabs.findIndex(
      (t) => t.id === activeSubTabId
    );
    return isFirstSection && currentSubTabIndex === 0;
  };

  // ✅ Check if we're on the last subtab of last section
  const isLastSubTab = () => {
    if (!activeSection?.subTabs?.length) return isLastSection;
    const currentSubTabIndex = activeSection.subTabs.findIndex(
      (t) => t.id === activeSubTabId
    );
    return isLastSection && currentSubTabIndex === activeSection.subTabs.length - 1;
  };

  const resolveOptions = (field) => {
    if (field.options_key && dropdownData[field.options_key]) {
      return dropdownData[field.options_key].map((v) => ({
        label: v,
        value: v,
      }));
    }

    if (field.options) {
      return field.options.map((opt) =>
        typeof opt === "string" ? { label: opt, value: opt } : opt
      );
    }

    return [];
  };

  const groupFieldsBySection = (fields) => {
    const groups = {};

    fields.forEach((field) => {
      const sectionName = field.section || "General Information";
      if (!groups[sectionName]) {
        groups[sectionName] = [];
      }
      groups[sectionName].push(field);
    });

    return groups;
  };

  const visibleFields = getVisibleFields(getFields());
  const groupedFields = groupFieldsBySection(visibleFields);

  // ✅ Render custom SAARC visits component
  const renderSaarcVisits = () => {
    const showSaarc = values.saarc_visit === "YES";
    if (!showSaarc) return null;

    return (
      <div className="md:col-span-2 space-y-4">
        {saarcVisits.map((visit, index) => (
          <div
            key={visit.id}
            className="relative border border-gray-200 rounded-lg p-6 bg-gray-50"
          >
            {/* Remove button - only show if more than one entry */}
            {saarcVisits.length > 1 && !readOnly && (
              <button
                type="button"
                onClick={() => onRemoveSaarcVisit(visit.id)}
                className="absolute top-4 right-4 text-red-500 hover:text-red-700 transition-colors"
                title="Remove this visit"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                </svg>
              </button>
            )}

            <h4 className="text-sm font-semibold text-gray-700 mb-4">
              SAARC Visit #{index + 1}
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* SAARC Country */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  SAARC Country
                </label>
                <select
                  value={visit.saarc_country}
                  onChange={(e) =>
                    onSaarcVisitChange(visit.id, "saarc_country", e.target.value)
                  }
                  disabled={readOnly}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                >
                  <option value="">Select SAARC Country</option>
                  {(MASTER_DATA.saarc_country || []).map((country) => (
                    <option key={country.value} value={country.value}>
                      {country.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Year */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Year
                </label>
                <input
                  type="text"
                  value={visit.saarc_year}
                  onChange={(e) =>
                    onSaarcVisitChange(visit.id, "saarc_year", e.target.value)
                  }
                  disabled={readOnly}
                  placeholder="e.g., 2023"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                />
              </div>

              {/* Number of Visits */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Number of Visits
                </label>
                <input
                  type="text"
                  value={visit.no_of_visits}
                  onChange={(e) =>
                    onSaarcVisitChange(visit.id, "no_of_visits", e.target.value)
                  }
                  disabled={readOnly}
                  placeholder="e.g., 2"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                />
              </div>
            </div>
          </div>
        ))}

        {/* Add Another Visit Button */}
        {!readOnly && (
          <button
            type="button"
            onClick={onAddSaarcVisit}
            className="flex items-center gap-2 px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Add Another SAARC Visit
          </button>
        )}
      </div>
    );
  };

  const renderMainContent = () => {
    if (usesCustomRenderer && CustomComponent) {
      return (
        <div className="p-8">
          <CustomComponent
            uploadedDocuments={uploadedDocuments}
            applicationId={applicationId}
             // ✅ Pass rounds and update callback to custom component
            rounds={additionalInfoRounds}
            onUpdate={onAdditionalInfoUpdate}
          />
        </div>
      );
    }

    return (
      <div className="p-8 max-h-[500px] overflow-y-auto">
        {Object.entries(groupedFields).map(([sectionName, fields]) => (
          <div key={sectionName} className="mb-8 last:mb-0">
            <div className="mb-4 pb-2 border-b border-gray-200">
              <h3 className="text-base font-semibold text-gray-800">
                {sectionName}
              </h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              {fields.map((field, index) => {
                const isFullWidth =
                  field.type === "textarea" ||
                  field.fullWidth ||
                  field.type === "checkbox";

                // ✅ Check if this is the SAARC visit trigger field
                const isSaarcTrigger = field.name === "saarc_visit";

                return (
                  <React.Fragment key={field.name || index}>
                    <div className={isFullWidth ? "md:col-span-2" : ""}>
                      <FieldRenderer
                        field={{
                          ...field,
                          options: resolveOptions(field),
                        }}
                        value={values[field.name]}
                        error={errors[field.name]}
                        onChange={onChange}
                        readOnly={readOnly}
                      />
                    </div>

                    {/* ✅ Render SAARC visits component right after the trigger field */}
                    {isSaarcTrigger && renderSaarcVisits()}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        ))}

        {visibleFields.length === 0 && !usesCustomRenderer && (
          <div className="text-center py-12 text-gray-500">
            <p>No fields to display in this section.</p>
          </div>
        )}
      </div>
    );
  };

  const sortedSections = [...config.sections].sort((a, b) => {
    if (a.id === 'additional_info_requested') return -1;
    if (b.id === 'additional_info_requested') return 1;
    return 0;
  });

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl">
      <div className="flex gap-6 p-6 max-w-7xl mx-auto">

        {/* SIDEBAR */}
        <aside className="w-72 flex-shrink-0 space-y-3 max-h-[600px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
          {sortedSections.map((section, index) => {
            const { total, filled, isDocumentSection } = getSectionStats(section);
            const isActive = section.id === activeSectionId;
            const isDone = total > 0 && filled === total;
            const percentage = total > 0 ? (filled / total) * 100 : 0;
            const isAccessible = isSectionAccessible(index);

            return (
              <button
                key={section.id}
                onClick={() => isAccessible && handleSectionChange(section.id)}
                disabled={!isAccessible}
                className={`w-full p-3.5 rounded-xl text-left transition-all duration-200 ${isActive
                    ? "bg-white shadow-lg border-2 border-blue-500"
                    : isAccessible
                      ? "bg-white/70 hover:bg-white hover:shadow-md hover:scale-[1.02] cursor-pointer"
                      : "bg-gray-100 opacity-50 cursor-not-allowed"
                  }`}
              >
                <div className="flex items-start gap-3 mb-2.5">
                  <span className="text-2xl flex-shrink-0 mt-0.5">
                    {icons[section.id] || "📄"}
                  </span>
                  <div className="flex-1 min-w-0 overflow-hidden">
                    <h4 className={`font-semibold text-sm leading-snug mb-1 ${isAccessible ? "text-gray-800" : "text-gray-400"
                      }`}>
                      {section.title}
                    </h4>
                    <p className="text-xs text-gray-500">
                      {isDocumentSection
                        ? `${total} document${total !== 1 ? 's' : ''}`
                        : `${filled}/${total} fields`
                      }
                    </p>
                  </div>
                  {isDone && (
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                  )}
                  {!isAccessible && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="flex-shrink-0 mt-0.5 text-gray-400"
                    >
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                  )}
                </div>

                <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-blue-500 rounded-full transition-all duration-500 ease-out"
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </button>
            );
          })}
        </aside>


        {/* FORM AREA */}
        <main className="flex-1 min-w-0" ref={mainFormRef} >
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

            {!usesCustomRenderer && activeSection?.subTabs && activeSection.subTabs.length > 0 && (
              <div className="border-b bg-gray-50 px-6 pt-4">
                <div className="flex gap-2 overflow-x-auto pb-0">
                  {activeSection.subTabs.map((tab) => {
                    const visibleTabFields = getVisibleFields(tab.fields || []);
                    const filled = getFilled(tab.fields || []);
                    const total = visibleTabFields.length;
                    const active = tab.id === activeSubTabId;
                    const isComplete = filled === total && total > 0;

                    return (
                      <button
                        key={tab.id}
                        onClick={() => setActiveSubTabId(tab.id)}
                        className={`px-6 py-3 rounded-t-lg font-medium text-sm transition-all whitespace-nowrap ${active
                          ? "bg-white text-blue-600 border-t-2 border-x-2 border-blue-600"
                          : "text-gray-600 hover:bg-white/50"
                          }`}
                      >
                        <div className="flex items-center gap-2">
                          <span>{tab.title}</span>
                          {isComplete && (
                            <CheckCircle2 className="w-4 h-4 text-green-500" />
                          )}
                        </div>
                        <div className="text-xs mt-1 opacity-90">
                          {filled}/{total}
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {renderMainContent()}

            {mode === "edit" && (
              <div className="border-t bg-gray-50 p-6 flex justify-between items-center">
                <button
                  onClick={handlePrevious}
                  disabled={isFirstSubTab()}
                  className={`px-6 py-2.5 rounded-lg font-medium transition-all ${isFirstSubTab()
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:shadow-md border border-gray-300"
                    }`}
                >
                  ← Previous
                </button>

                {!isLastSubTab() && (
                  <button
                    onClick={handleNext}
                    className="px-6 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 shadow-md font-medium transition-all flex items-center gap-2"
                  >
                    <span>Next</span>
                    <span>→</span>
                  </button>
                )}
              </div>
            )}

            {(mode === "review" || mode === "view") && (
              <div className="border-t bg-gray-50 p-6 text-center">
                {/* Review mode info */}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default PassengerFormTabs;
